<!-- https://svelte.dev/repl/0d592275ba814ea682a4292b401f0421?version=3.53.1 -->
<script>
  import { fly, fade } from 'svelte/transition';
  import { alertReload, contact, contactIsOpen } from '../stores.js';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate, useFocus } from 'svelte-navigator';
  export let navigate;
  navigate = useNavigate();
  import Body from './Body.svelte';
  import Item from './Item.svelte';
  let active = null;

  // $alertReload = false;

  function close() {
    // const btnContact = document.querySelector('.as-btn-contact');
    // btnContact.classList.remove('disabled');
    navigate(-1);
  }
</script>

<!-- <svelte:head>
  <link
    href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css"
    rel="stylesheet"
  />
</svelte:head> -->

<div class="as-container-neu">
  <div class="as-container mx-auto relative">
    <div class="close" on:click="{() => close()}">
      <iconify-icon icon="ant-design:close-circle-filled" width="60" height="60"
      ></iconify-icon>
    </div>
    <div class="as-titre-1">FAQ</div>

    <div class="py-10">
      <Body bind:active>
        <div class="as-soustitre">Particuliers</div>
        <!-- <Item
          id="0"
          title="Je souhaite une trappe sur mesure pour ma maison, est-ce que je peux commander sur le comptoir des trappes ?"
        >
          <h1>
            Vous pouvez faire votre demande de trappe sur le comptoir des
            trappes, un distributeur de nos trappes vous recontactera avec une
            proposition de tarif et c’est auprès de lui que vous pourrez passer
            votre commande, payer et retirer votre trappe.
          </h1>
        </Item> -->
        <Item
          id="1"
          title="Je souhaite une trappe sur mesure pour ma maison, est-ce que je peux commander sur le comptoir des trappes ?"
        >
          <h1>
            Vous pouvez faire votre demande de trappe sur le comptoir des
            trappes, un distributeur de nos trappes vous recontactera avec une
            proposition de tarif et c’est auprès de lui que vous pourrez passer
            votre commande, payer et retirer votre trappe.
          </h1>
        </Item>
        <Item id="2" title="Est-ce que Semin me vends directement la trappe ?">
          <h1>
            Non. Vous faites votre demande de trappe sur mesure sur le comptoir
            des trappes, un distributeur de nos trappes vous recontactera avec
            une proposition de tarif et c’est auprès de lui que vous pourrez
            passer votre commande, payer et retirer votre trappe.
          </h1>
        </Item>
        <Item
          id="3"
          title="A quel moment puis-je choisir mon point de retrait ?"
        >
          <h1>
            Vous pouvez indiquez dans vos coordonnées un lieu de retrait
            souhaité, mais nous ne garantissons pas ce point.
          </h1>
        </Item>
        <Item id="4" title="A quel moment dois-je payer ?">
          <h1>
            Cela dépend du distributeur qui s’occupera de votre commande. Il
            vous donnera tous les éléments lors de la présentation du devis.
          </h1>
        </Item>

        <div class="as-soustitre">Entreprise</div>

        <Item
          id="5"
          title="Je souhaite une trappe sur mesure pour un chantier, est-ce que je peux commander sur le comptoir des trappes ?"
        >
          <h1>
            Vous pouvez faire votre demande de trappe sur le comptoir des
            trappes, un distributeur de nos trappes vous recontactera avec une
            proposition de tarif et c’est auprès de lui que vous pourrez passer
            votre commande, payer et retirer votre trappe.
          </h1>
        </Item>

        <Item id="6" title="Est-ce que Semin me vends directement la trappe ?">
          <h1>
            Non. Vous faites votre demande de trappe sur mesure sur le comptoir
            des trappes, un distributeur de nos trappes vous recontactera avec
            une proposition de tarif et c’est auprès de lui que vous pourrez
            passer votre commande, payer et retirer votre trappe.
          </h1>
        </Item>

        <Item
          id="7"
          title="A quel moment puis-je choisir mon point de retrait ?"
        >
          <h1>
            Vous pouvez indiquez dans vos coordonnées un lieu de retrait
            souhaité, mais nous ne garantissons pas ce point.
          </h1>
        </Item>

        <Item
          id="8"
          title="J’ai déjà commandé des trappes Semin chez mon distributeur habituel, je souhaite repasser par ce point, est-ce possible ?"
        >
          <h1>
            Vous pouvez indiquez dans vos coordonnées votre lieu de préférence.
            Vous pouvez également contacter votre distributeur habituel qui nous
            transmettra la demande de trappe.
          </h1>
        </Item>

        <Item id="9" title="A quel moment dois-je payer ?">
          <h1>
            Cela dépend du distributeur qui s’occupera de votre commande. Il
            vous donnera tous les éléments lors de la présentation du devis.
          </h1>
        </Item>

        <div class="as-soustitre">Négociant</div>

        <Item
          id="10"
          title="Je n’ai pas mon code négociant, comment puis-je l’obtenir ?"
        >
          <h1>Vous pouvez le demander à votre commercial Semin habituel.</h1>
        </Item>
      </Body>
    </div>
  </div>
</div>

<style>
  .as-soustitre {
    font-family: 'introblack';
    color: #000;
    font-size: 35px;
    padding: 35px 0 10px;
  }
  .asLinkPdc {
    border-bottom: 1px solid black;
    cursor: pointer;
    transition: all 400ms;
  }
  .asLinkPdc:hover {
    border-bottom: 1px solid #0002;
  }
  /* .as-soustitre {
    font-family: 'introblack';
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 30px;
  } */
  .as-container-neu {
    position: relative;
  }
  .close {
    position: absolute;
    top: 0;
    right: 80px;
    cursor: pointer;
  }
  .as-titre-1,
  .as-titre-2 {
    font-family: 'introblack';
    font-size: 95px;
    line-height: 70px;
    text-align: left;
    transition: color 300ms;
  }
  .as-titre-1 {
    font-size: 90px;
    color: transparent;
    -webkit-text-stroke: 2px #000;
    padding-top: 30px;
  }
  .as-titre-2 {
    color: #000;
    font-size: 115px;
    padding-bottom: 30px;
  }
  select {
    background-image: linear-gradient(45deg, transparent 50%, #545454 50%),
      linear-gradient(135deg, #545454 50%, transparent 50%);
    background-position: calc(100% - 30px) calc(1em + 12px),
      calc(100% - 25px) calc(1em + 12px);
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
  }
  .error {
    /* font-family: 'introlight'; */
    margin-top: 40px;
    color: red;
  }
  textarea.as-input-neu {
    min-height: 150px;
    border-radius: 30px;
    padding: 20px 25px;
  }
  .as-validation {
    font-family: 'introlight';
    margin-top: 30px;
  }
  .btn-valid {
    text-align: right;
  }
  .as-btn-rounded {
    margin-top: 20px;
    padding: 12px 45px;
  }
  @media only screen and (max-width: 768px) {
    .as-container-neu {
      padding: 10px 40px;
    }
    .close {
      top: 0;
      right: 0;
    }
    .as-titre-1,
    .as-titre-2 {
      line-height: 8vw;
    }
    .as-titre-1 {
      padding-top: 80px;
      margin-top: 30px;
      font-size: 13vw;
    }
    .as-titre-2 {
      font-size: 13vw;
      padding-bottom: 0;
    }
    .grid-cols-3 {
      display: block;
    }
    .grid-cols-3 > div {
      margin-bottom: 40px;
    }
    .as-btn-rounded {
      margin-top: 5px;
      margin-bottom: 20px;
    }
  }
</style>
